<template lang="html">
	<v-error type="404"></v-error>
</template>

<script>

import Error from '@/components/common/error/Error.vue';

export default {
	name : 'Page404',
	components : {
		'v-error' : Error
	}
}
</script>



// WEBPACK FOOTER //
// src/components/404/404.vue